module.exports = __webpack_public_path__ + "static/img/A14.a02a90b4.jpg";